// ===============================
// pages/Contact.jsx
// ===============================

import React, { useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/api"; // Ensure this path is correct for your project
import "./Contact.css";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic Validation
    if (!formData.firstName.trim() || !formData.email.trim() || !formData.message.trim()) {
      toast.error("Please fill in all required fields.");
      return;
    }

    try {
      setLoading(true);
      
      // Send data to backend
      const res = await api.post("/api/contact", formData);
      
      toast.success(res.data?.message || "Message sent successfully!");
      
      // Clear form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* PAGE BANNER */}
      <div className="page-banner">
        <h1>Contact Us</h1>
      </div>

      <div className="container contact-wrapper">
        {/* LEFT SIDE */}
        <div className="contact-info">
          <span className="contact-tag">GET IN TOUCH</span>
          <h2>We'd Love To Hear From You</h2>
          <p>
            Have questions about products, shipping, or orders? Our team is ready to help you anytime.
          </p>

          {/* INFO BOXES */}
          <div className="info-box">
            <div className="info-icon">
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <div>
              <h4>Address</h4>
              <p>#5 Sarsehri, Ambala Cantt, Haryana, India</p>
            </div>
          </div>

          <div className="info-box">
            <div className="info-icon">
              <i className="fa-solid fa-phone"></i>
            </div>
            <div>
              <h4>Phone</h4>
              <p>+91 83077 26652</p>
            </div>
          </div>

          <div className="info-box">
            <div className="info-icon">
              <i className="fa-solid fa-envelope"></i>
            </div>
            <div>
              <h4>Email</h4>
              <p>info@versacore.in</p>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="contact-form-box">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="input-row">
              <input
                type="text"
                name="firstName"
                placeholder="First Name *"
                value={formData.firstName}
                onChange={handleChange}
                disabled={loading}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                disabled={loading}
              />
            </div>

            <input
              type="email"
              name="email"
              placeholder="Email Address *"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
              required
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              disabled={loading}
            />

            <textarea
              name="message"
              rows="6"
              placeholder="Write your message... *"
              value={formData.message}
              onChange={handleChange}
              disabled={loading}
              required
            ></textarea>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;